import { useContext } from 'react';
import * as R from 'ramda';

import ElementInfoBox from '@atom/components/common/moveElement/ElementInfoBox';
import { Icon } from '@atom/mui';
import colors from '@atom/styles/colors';

import ReplaceElementModalContext from './ReplaceElementModalContext';

import classes from './replaceElement.module.css';

const styles = {
  icon: {
    marginRight: '1rem',
  },
};

const ConfirmStep = () => {
  const {
    element,
    destinationAssetPath,
    replacementAsset,
    replacementAssetPath,
    rootAsset,
  } = useContext(ReplaceElementModalContext);

  const fromMoveElementDisplay = element.ancestors
    .map(item => item.name)
    .join(' / ');
  const toMoveElementDisplay = destinationAssetPath
    .map(item => item.name)
    .join(' / ');
  const toMoveRootAssetId = R.head(destinationAssetPath)?.id;

  const fromReplacementElementDisplay = R.dropLast(
    1,
    replacementAssetPath.map(item => item.name),
  ).join(' / ');
  const toReplacementElementDisplay = element.ancestors
    .map(item => item.name)
    .join(' / ');
  const fromReplacementRootAssetId = R.head(replacementAssetPath)?.id;

  return (
    <div className={classes.listContainer}>
      <div className={classes.confirmHeader}>
        Are you sure you want to complete this replacement?
      </div>
      <ElementInfoBox
        element={replacementAsset}
        fromAssetDisplay={fromReplacementElementDisplay}
        fromAssetId={fromReplacementRootAssetId}
        toAssetDisplay={toReplacementElementDisplay}
        toAssetId={rootAsset.id}
        isReplaceElement
      />
      <ElementInfoBox
        element={element}
        fromAssetDisplay={fromMoveElementDisplay}
        fromAssetId={rootAsset.id}
        toAssetDisplay={toMoveElementDisplay}
        toAssetId={toMoveRootAssetId}
      />
      <div className={classes.infoSection}>
        <Icon style={styles.icon} color={colors.brand.blue}>
          error_outline
        </Icon>
        <div>
          <div>Moving sub items will also:</div>
          <ul className={classes.list}>
            <li>
              Move any nested sub items if they exist, media (photos, documents,
              and videos), and pending changes.
            </li>
            <li>Reassign open work to the new parent.</li>
            <li>Keep closed work with the original parent.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ConfirmStep;
